import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Upload, X, Image as ImgIcon } from 'lucide-react';
import { API, resolveImageUrl } from '../../context/SiteConfigContext';

const ImageUploader = ({ label, value, onChange, token, aspect = 'aspect-video' }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const ref = useRef();

  const handleFile = async (file) => {
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await axios.post(`${API}/admin/upload`, fd, {
        headers: { 'X-Admin-Token': token, 'Content-Type': 'multipart/form-data' },
      });
      onChange(data.url);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Upload échoué');
    } finally {
      setUploading(false);
    }
  };

  const src = resolveImageUrl(value);

  return (
    <div>
      {label && <label className="block text-[11px] tracking-[0.15em] uppercase text-white/50 mb-1.5">{label}</label>}
      <div className={`relative ${aspect} rounded-lg overflow-hidden border border-white/10 bg-[#0a1f1a] group`}>
        {src ? (
          <img src={src} alt="" className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <div className="absolute inset-0 grid place-items-center text-white/30">
            <ImgIcon size={26} />
          </div>
        )}

        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={() => ref.current?.click()}
            className="inline-flex items-center gap-2 rounded-md bg-white/90 text-black text-[12px] font-medium px-3 py-1.5"
          >
            <Upload size={13} />
            {uploading ? 'Envoi…' : (src ? 'Remplacer' : 'Uploader')}
          </button>
          {src && (
            <button
              type="button"
              onClick={() => onChange('')}
              className="inline-flex items-center gap-1 rounded-md bg-black/70 text-white text-[12px] px-2.5 py-1.5"
            >
              <X size={12} /> Retirer
            </button>
          )}
        </div>
      </div>
      <input
        ref={ref}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      {error && <p className="mt-1 text-[11px] text-[#f27a5b]">{error}</p>}
      <p className="mt-1 text-[10.5px] text-white/30">Max 3 Mo. JPG / PNG / WebP</p>
    </div>
  );
};

export default ImageUploader;
